export default __webpack_public_path__ + "static/media/pricing-image-05.a61137d8.png";